export default __webpack_public_path__ + "static/media/sorektNft.a59b749c.png";